import { HttpClient } from "../HttpClient";
/**
 * * Post Cash Advances
 */

export const PostCashAdvances = async(params) => {
  try {
    const { data } = await HttpClient.post('api/instacash/cashadvances/searchcriteria', { ...params });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
